import { AssignType } from '../graphql/assignDrivers';
import { t } from '../../../../i18n';

/**
 * 指派方式数值 → 显示文案（复用 splitOrder.history.* 国际化 key，保证各页面展示一致）。
 * 0-直接指派 1-序列(Stop) 2-邮编(Zipcode) 3-地图圈选 4-算法
 */
export function getAssignTypeLabel(assignType: number | null | undefined): string {
  switch (assignType) {
    case AssignType.BY_MAP:
      return t('splitOrder.history.mapSelect');
    case AssignType.BY_ZIPCODE:
      return t('splitOrder.history.zipcodeAssign');
    case AssignType.BY_STOP:
      return t('splitOrder.history.stopAssign');
    case AssignType.BY_ALGORITHM:
      return t('splitOrder.history.algoAssign');
    case AssignType.DIRECT:
      return t('splitOrder.history.directAssign');
    default:
      return '—';
  }
}
